import { useUserStore } from '@/config/store/userStore'
import { getDefaultManagementHome } from '@/config/router/navigationsGuards/guardManagement'

type TAcademyUser = { _firmId?: string | null, role?: string | string[] | null } | null | undefined

/** The role may come as an array: compare values, never `String.includes` ('client_admin' contains 'admin'). */
export const hasAcademyRole = (user: TAcademyUser, role: string) => {
  const roles = Array.isArray(user?.role) ? user.role : [user?.role]
  return roles.some(currentRole => currentRole === role)
}

/** Every user of a firm learns BestConsultant, whatever their profile or the modules of their firm. */
export const canUseAcademy = (user: TAcademyUser) => !!user?._firmId

/** Following the collaborators' progress is for the firm's administrators. */
export const canFollowAcademyTeam = (user: TAcademyUser) => canUseAcademy(user) && hasAcademyRole(user, 'client_admin')

export const guardAcademyAccess = () => {
  const user = useUserStore().user
  if (canUseAcademy(user)) return true
  // BestConsultant admins have no firm, hence no progress to keep.
  return user?.role === 'admin' ? getDefaultManagementHome(user) : { name: 'Home' }
}

export const guardAcademyTeam = () => {
  const user = useUserStore().user
  if (canFollowAcademyTeam(user)) return true
  return canUseAcademy(user) ? { name: 'AcademyHome' } : guardAcademyAccess()
}
